export const styleCard = (themeColors) => ({
    '.ant-card': {
        '&.credit-card': {
            backgroundColor: themeColors.mediumColor,
            '.ant-typography': {
                color: '#fff'
            }
        },
    }
})